<template>
    <div class="bodygenerico">

      <!-- Mobile master-detail: one panel at a time with slide transition -->
      <div class="bodyFlex bodyFlex--master-detail" v-if="isMobile">
        <transition :name="slideName" mode="out-in">
          <ColunaListaPedidos
            v-if="!pedido"
            key="lista"
            :ojbPedidos="ojbPedidos"
            @setarPedido="(pedido) => setarPedido(pedido)"
            :buscainicial="query"
            :tela="'GARCOM'"
          />
          <ColunaPedido
            v-else
            key="detalhe"
            :pedido="pedido"
            @imprimirComanda="(pedido) => imprimirComanda(pedido)"
            @setarPedido="(pedido) => setarPedido(pedido)"
            :exibirnao="true"
            @nao="(pedido) => cancelarPedido(pedido)"
            @sim="(pedido) => marcarComoEntregue(pedido)"
            @marcarItemComoEntregue="(objeto) => marcarItemComoEntregue(objeto)"
            @listarComandas="() => listarPedidosIniciais(idstatuspadraotela)"
            :tela="'GARCOM'"
            textonao="Cancelar Todos os Itens"
            textosim="Marcar Como Entregue"
            categoria="14"
            legenda="Duvidas Garcom"
            urlVideo="https://www.youtube.com/embed/Tcd3VnK4IW8"
          />
        </transition>
      </div>

      <!-- Desktop side-by-side layout (unchanged) -->
      <div class="bodyFlex" v-else>
          <ColunaListaPedidos :ojbPedidos="ojbPedidos" @setarPedido="(pedido) => setarPedido(pedido)" :buscainicial="query"/>
          <ColunaPedido v-if="pedido" :pedido="pedido" @imprimirComanda="(pedido) => imprimirComanda(pedido)" @setarPedido="(pedido) => setarPedido(pedido)"
            :exibirnao="true" @nao="(pedido) => cancelarPedido(pedido)" @sim="(pedido) => marcarComoEntregue(pedido)"
            @marcarItemComoEntregue="(objeto) => marcarItemComoEntregue(objeto)"
            @listarComandas="() => listarPedidosIniciais(idstatuspadraotela)"
            :tela="'GARCOM'"
            textonao="Cancelar Todos os Itens" textosim="Marcar Como Entregue" categoria="14" legenda="Duvidas Garcom" urlVideo="https://www.youtube.com/embed/Tcd3VnK4IW8"
              />
      </div>

      <ModalImpressaoPedido :showModal="showModal" :pedidoSelecionado="pedidoSelecionado" :dataImpressao="dataImpressao" />
      <!-- MODAL IMPRESSAO -->


    </div>
</template>

<script>

import ColunaListaPedidos from '../../components/pedidos/ColunaListaPedidos.vue'
import ColunaPedido from '../../components/pedidos/ColunaPedido.vue'
import ModalImpressaoPedido from '../../components/layout/ModalImpressaoPedido.vue'

const dayjs = require('dayjs')

export default {
  name: 'ViewGarcom',
  components:{
    ColunaListaPedidos,
    ColunaPedido,
    ModalImpressaoPedido
  },
  data: () => ({
    exibirTaxa:false,
    idstatuspadraotela:"9,8,4",
    ojbPedidos:null,
    pedido:null,
    showModal:false,
    dataImpressao: dayjs().format('DD/MM/YYYY HH:mm:ss'),
    marcarefecharcomandaweb:false,
    pedidoSelecionado:{
            nomehotel:localStorage.getItem('nomehotel'),
            idcomanda:0,
            nomehospede:'',
            numerolocal:'',
            datapedido:dayjs().format(),
            quantidade:0,
            precototal:0,
            itens:[{
                    nomeproduto:'',
                    valorunitario:0.00,
                    qtde:0
                }]
        },
    query: '',
    // slide direction: 'forward' (list→detail) or 'back' (detail→list)
    direction: 'forward',
  }),
  computed: {
    // Use Vuetify 2 breakpoint — NOT breakpoint.mobile (follows D-01)
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    slideName() {
      return this.direction === 'forward'
        ? 'slide-x-reverse-transition'
        : 'slide-x-transition'
    }
  },
  watch: {
    // Navigate to list when Bar dispatches request_mobile_back
    '$store.state.mobileDetail.backTick'() {
      if (this.isMobile) this.mostrarLista()
    },
    // Keep showBack in sync when breakpoint crosses boundary
    isMobile(newVal) {
      if (newVal && this.pedido) {
        this.$store.dispatch('set_mobile_detail_show_back', true)
      } else if (!newVal) {
        this.$store.dispatch('set_mobile_detail_show_back', false)
      }
    },
    //quando eu faco uma pesquisa e sou redirecionada para a mesma pagina que estou
    '$route': function(to, from){
      if(to.path == from.path){
        if(to.query.numpedido !== from.query.numpedido){
          this.query = to.query.numpedido
        }
      }
    },
  },
  methods:{
      continuar(){
          this.$router.push('/Hospede/Menu')
      },
      // Return to the list panel and clear detail state
      mostrarLista() {
        this.direction = 'back'
        this.pedido = null
        this.$store.dispatch('set_mobile_detail_show_back', false)
      },
      async checarItensEmOutrosLugares(idComanda){

        const comandas = await this.$http.post('/pdv/checarItensEmOutrosLugares',{idcomanda:idComanda})
        .then(res => res.data)
        .catch((err) => {console.log(err); return []})
        return comandas
      },
      async marcarItemComoEntregue(objeto){
            // console.log('pedido >>>> ',JSON.stringify(this.pedido,null,2))

            objeto.pedidoitem.idstatusnovo = 5
            // objeto.pedidoitem.notificararea = 'GARCOM'
            // this.$http.post('pdv/alterarStatusItem',objeto.pedidoitem).then((resp) =>{
            //     console.log(resp)
            //     this.getProdutosdoAposLiberacaoPorItem({idcomanda:objeto.pedidoitem.idcomanda,pedido:objeto.pedido})
            // })
            // .catch(error =>{
            //     alert(error)
            //     console.log(error)
            // })

            const itemsEmOutroLugar = await this.checarItensEmOutrosLugares(objeto.pedidoitem.idcomanda)

            // if(itemsEmOutroLugar.totalProdutos > 0) {
            if(itemsEmOutroLugar.totalProdutos == 0) {
              return this.$alertar('warning','Este é o último item do pedido, para marcar como entregue, clique no botao abaixo', '=(')
            }

            this.$http.post('pdv/marcarItemComoEntregue',objeto.pedidoitem).then(async () =>{
                await this.getProdutosdoAposLiberacaoPorItem({idcomanda:objeto.pedidoitem.idcomanda,pedido:objeto.pedido, itemsEmOutroLugar})
            })
            .catch(error =>{
                alert(error)
                console.log(error)
            })



      },
      async getProdutosdoAposLiberacaoPorItem(dados){

        this.pedido = null
        this.pedido = await this.getProdutosdoPedido(dados.idcomanda)
       try {
          if(!this.pedido || (this.pedido && this.pedido.listadepedidos.length == 0 || this.pedido.listadepedidos.length == 1)){

            const itemsEmOutroLugar = dados.itemsEmOutroLugar

            console.log('itemsEmOutroLugar >>>> ',itemsEmOutroLugar)
            let novoStatus = 3

            if(itemsEmOutroLugar.totalProdutosProducaoBar > 0) {
              novoStatus = 11
            } else if(itemsEmOutroLugar.totalProdutosProducaoCozinha > 0) {
              novoStatus = 10
            }

            const dadosMudarStatusComanda =  {
              idcomanda: dados.idcomanda,
              novoStatus: novoStatus
            }

            await this.mudarStatusComanda(dadosMudarStatusComanda)
          }
        } catch (error) {
          console.log(error)
        }
      },

      async mudarStatusComanda({idcomanda,novoStatus}){

        const url = `pdv/alterarStatusPedidoEProdutos/${idcomanda}/${novoStatus}`

        const data = {
          id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario")
        }

        this.$http.post(url, data).
        then(() =>{
          this.listarPedidosIniciais(this.idstatuspadraotela)
        })
        .catch(error =>{
            alert(error)
            console.log(error)
        })
      },

      async getComandasReservaPorStatus(idreservasfront,idstatus){

        console.log('idreservasfront >>>> ',idreservasfront)
        console.log('idstatus >>>> ',idstatus)

            let objetoRetorno = {}
            await this.$http('pdv/getComandasReservaPorStatus/'+idreservasfront+'/'+idstatus+'/t').then((resp) =>{
              console.log(resp.data)
              objetoRetorno.valorTotal = 0
              objetoRetorno.listadepedidos = resp.data
              for(var i = 0, len = objetoRetorno.listadepedidos.length; i < len; i++){
                  objetoRetorno.valorTotal += parseFloat(objetoRetorno.listadepedidos[i].valor)
                  objetoRetorno.statuscomanda = objetoRetorno.listadepedidos[i].statuscomanda
                  this.exibirTaxa = objetoRetorno.listadepedidos[i].exibirtaxa == 'true' ? true:false
              }
            }).catch(error =>{
              console.log(error)
              this.$alertar("warning","Não foi possivel exibir os pedidos","=(")
            })

            return objetoRetorno
      },
      async getProdutosdoPedido(numpedido){
            let objetoRetorno = {}
            await this.$http('pdv/getProdutosdoPedido/'+numpedido+'/t/9').then((resp) =>{
              if(resp.data?.length > 0) {
                objetoRetorno.valorTotal = 0
                objetoRetorno.valorTotalSemTaxa = 0
                objetoRetorno.numpedido = resp.data[0].idcomanda
                objetoRetorno.marcado_como_entregue = resp.data[0].marcado_como_entregue
                objetoRetorno.datafeito = resp.data[0].datahoraabertura
                objetoRetorno.datarecebido = resp.data[0].datarecebidogarcom
                objetoRetorno.imgassinatura = resp.data[0].imgassinatura
                objetoRetorno.idtipolocal = resp.data[0].idtipolocal
                objetoRetorno.numerolocal = resp.data[0].numerolocal
                objetoRetorno.numreserva = resp.data[0].numreserva
                objetoRetorno.coduh = resp.data[0].coduh
                objetoRetorno.nome = resp.data[0].nome
                objetoRetorno.sobrenome = resp.data[0].sobrenome
                objetoRetorno.idgarcominicial = resp.data[0].idgarcominicial
                objetoRetorno.nomegarcominicial = resp.data[0].nomegarcominicial
                objetoRetorno.idgarcomatual = resp.data[0].idgarcomatual
                objetoRetorno.idstatuscomanda = resp.data[0].idstatuscomanda
                objetoRetorno.nomegarcom = resp.data[0].nomegarcom
                objetoRetorno.nomepdv = resp.data[0].nomepdv
                objetoRetorno.passante = resp.data[0].passante
                objetoRetorno.nomegarcomitem = resp.data[0].nomegarcomitem
                objetoRetorno.id_tipo_hospede_hits = resp.data[0].id_tipo_hospede_hits

                objetoRetorno.listadepedidos = resp.data

                for(var x = 0, lenx = objetoRetorno.listadepedidos.length; x < lenx; x++){
                  let horalimite = dayjs(objetoRetorno.listadepedidos[x].data_criacao_comandaproduto)
                                      .add(objetoRetorno.listadepedidos[x].tempopreparo,'minute').format('YYYY-MM-DD HH:mm:ss')
                  objetoRetorno.listadepedidos[x].horalimite = horalimite
                }


                for(var i = 0, len = resp.data.length; i < len; i++){
                    // objetoRetorno.valorTotal += (parseFloat(resp.data[i].precounitario) * parseFloat(resp.data[i].quantidade))
                    if(resp.data[i].valortotal > 0){
                      objetoRetorno.valorTotal += (parseFloat(resp.data[i].valortotal))
                      //console.error(`objetoRetorno.listadepedidos[i].valorsemtaxa:${objetoRetorno.listadepedidos[i].valorsemtaxa}`);
                      objetoRetorno.valorTotalSemTaxa += (parseFloat(objetoRetorno.listadepedidos[i].valorsemtaxa))
                    }
                }
                //console.error(`objetoRetorno.valorTotalSemTaxa:${objetoRetorno.valorTotalSemTaxa}`);
              }
            }).catch(error =>{
              console.log(error)
              this.$alertar("warning","Não foi possivel exibir os pedidos","=(")
            })

            if(!objetoRetorno?.numpedido){
              objetoRetorno = null
            }
            return objetoRetorno
      },
      async setarPedido(objpedido){
        this.direction = 'forward'
        this.pedido = null
        this.pedido = await this.getProdutosdoPedido(objpedido.numpedido)
        this.pedido.tempocategoria = objpedido.tempocategoria
        this.pedido.temposubcategoria = objpedido.temposubcategoria

        let imagemAssinatura = null

        await this.$http('pdv/getassinaturacomanda/'+objpedido.numpedido).then(resp =>{
                imagemAssinatura= resp.data[0].imgassinatura
            }).catch(error =>{
                console.log(error)
        })

        this.pedidoSelecionado = {
                nomehotel:localStorage.getItem('nomehotel'),
                idcomanda:this.pedido.numpedido,
                nomehospede:this.pedido.nome,
                numerolocal:this.pedido.numerolocal,
                datapedido:dayjs(this.pedido.datafeito).format('DD/MM/YYYY HH:mm'),
                quantidade:this.pedido.listadepedidos.length,
                precototal:this.pedido.valorTotal,
                itens:this.pedido.listadepedidos,
                imgassinaturasrc:imagemAssinatura
            }
      },
      async imprimirComanda() {
            this.dataImpressao = dayjs().format('DD/MM/YYYY HH:mm:ss')
            this.showModal = true   
            await this.registraLogImpressao()
            await this.recarregarPedidos(this.pedidoSelecionado.idcomanda)
            setTimeout(() => this.$htmlToPaper('modalImpressao'), 4000);
            // this.$htmlToPaper('modalImpressao')
      },
      async registraLogImpressao() {

        const logMSG = {
          message: "Tentativa de impressão da comanda apartir de botão na web, na qual não interfere no campo flimpresso, a partir da tela de Garçom",
          pedido: this.pedidoSelecionado,
          tela: "Garçom"
        }

        const data = {
          tipo: 101,
          idusuario: localStorage.getItem('idusuario'),
          descricao: "Impressão de comanda pelo botão web",
          log: JSON.stringify(logMSG, null, 2),
        }

        await this.$http.post("/pdv/registraLogMovimentacaoCD", data)
      },
      async recarregarPedidos(numpedido){

          this.pedido = await this.getProdutosdoPedido(numpedido)
          this.pedido.tempocategoria = this.ojbPedidos.listadepedidos[0].tempocategoria
          this.pedido.temposubcategoria = this.ojbPedidos.listadepedidos[0].temposubcategoria

          let imagemAssinatura= null

          await this.$http('pdv/getassinaturacomanda/'+numpedido).then(resp =>{
                  imagemAssinatura = resp.data[0].imgassinatura
              }).catch(error =>{
                  console.log(error)
          })

          this.pedidoSelecionado = {
                    nomehotel:localStorage.getItem('nomehotel'),
                    idcomanda:this.pedido.numpedido,
                    nomehospede:this.pedido.nome,
                    numerolocal:this.pedido.numerolocal,
                    datapedido:dayjs(this.pedido.datafeito).format('DD/MM/YYYY HH:mm'),
                    quantidade:this.pedido.listadepedidos.length,
                    precototal:this.pedido.valorTotal,
                    itens:this.pedido.listadepedidos,
                    imgassinaturasrc:imagemAssinatura
                }
      },
      async listarPedidosIniciais(idstatus){

        this.ojbPedidos = await this.getComandasReservaPorStatus(0,idstatus)
         if( this.ojbPedidos.listadepedidos &&  this.ojbPedidos.listadepedidos.length > 0){

            this.ojbPedidos.listadepedidos[0].atrasado= true
            this.exibirTaxa = this.ojbPedidos.listadepedidos[0].exibirtaxa == 'true' ? true:false

            // On mobile, don't auto-select the first order — show the list first
            if (this.isMobile) return

            this.pedido = await this.getProdutosdoPedido(this.ojbPedidos.listadepedidos[0].numpedido)
            this.pedido.tempocategoria = this.ojbPedidos.listadepedidos[0].tempocategoria
            this.pedido.temposubcategoria = this.ojbPedidos.listadepedidos[0].temposubcategoria

            let imagemAssinatura= null

            await this.$http('pdv/getassinaturacomanda/'+this.ojbPedidos.listadepedidos[0].numpedido).then(resp =>{
                    imagemAssinatura = resp.data[0].imgassinatura
                }).catch(error =>{
                    console.log(error)
            })

            this.pedidoSelecionado = {
                      nomehotel:localStorage.getItem('nomehotel'),
                      idcomanda:this.pedido.numpedido,
                      nomehospede:this.pedido.nome,
                      numerolocal:this.pedido.numerolocal,
                      datapedido:dayjs(this.pedido.datafeito).format('DD/MM/YYYY HH:mm'),
                      quantidade:this.pedido.listadepedidos.length,
                      precototal:this.pedido.valorTotal,
                      itens:this.pedido.listadepedidos,
                      imgassinaturasrc:imagemAssinatura
            }

         }else{
           this.pedido = null
         }

      },
      enviarPagamento(pedido){

           let obj = {
                      numpedido:pedido.numpedido,
                      tipopagamento:pedido.tipoPagamentoSelecionado,
                      valorpagamento:parseFloat( pedido.cobrartaxas.id == 1 ? pedido.valorTotal: pedido.valorTotalSemTaxa ),
                      cobrartaxa:pedido.cobrartaxas.id,
                      nsu:pedido.nsu
                    }

            this.$http.post(`/pdv/enviarPagtoPassante`,obj).then(resp =>{
                if(resp.status == 200){
                    this.entregar(pedido, true)
                }
            }).catch(error =>console.log('ERRO RETNORO ',error))
        },
      async entregar(pedido, passante){
        const permitirFechamentoPassanteGarcom = await this.$http.post(`/pdv/buscarparametros`, {chave: 'FLUXOPEDIDOS'})
        .then(res => JSON.parse(res.data[0].valor6).permitirFechamentoPassanteGarcom)
        let url = `pdv/alterarStatusPedidoEProdutos/${pedido.numpedido}/5`

        if(this.marcarefecharcomandaweb && !passante){
          url = `pdv/alterarStatusPedidoEProdutos/${pedido.numpedido}/5/f`
        }else if(this.marcarefecharcomandaweb && passante && permitirFechamentoPassanteGarcom){
          url = `pdv/alterarStatusPedidoEProdutos/${pedido.numpedido}/5/f`
        }

        let numlocalformatado = pedido.numerolocal ? pedido.numerolocal.split('-')[0].trim():''
        const dados = {
          id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario"),
          flgarcom:true,
          // numerolocal:pedido.numerolocal,
          numerolocal:numlocalformatado,
          fl_marcado_como_entregue_pela_web: true,
          web: true,
        }

        await this.$http.post(url,dados).then(()=>{
          this.$alertar("success","Pedido Entregue!","=)")
          this.listarPedidosIniciais(this.idstatuspadraotela)
          this.pedido = null
        }).catch(()=>{
          this.$alertar("warning","Não foi possível Enviar Pedido Para Entregue!","=(")
        })
      },
      async marcarComoEntregue(pedido){

        const fechamentoAutomatico = await this.$http.post('pdv/buscarparametros',{chave:'FLUXOPEDIDOS'})
            .then(resp =>{
                let fechamentoAutomatico = JSON.parse(resp.data[0].valor6);
                if (fechamentoAutomatico) {
                  return fechamentoAutomatico.permitirFechamentoPassanteGarcom
                }
            }).catch(error =>{
                alert(error)
            })

          if(pedido.passante && fechamentoAutomatico){
            this.enviarPagamento(pedido)
          }else if(pedido.passante){
            this.entregar(pedido, true)
          } else {
            this.entregar(pedido, false)
          }

      },
      async cancelarPedido(pedido){
        console.log("PEDD")
        console.log(pedido)

        const data = {
          id_ultimo_usuario_atualizacao: localStorage.getItem("idusuario"),
        }

        await this.$http.post(`pdv/alterarStatusPedidoEProdutos/${pedido.numpedido}/6`, data).then(()=>{
           this.$alertar("success","Pedido Cancelado!","=)")
           this.listarPedidosIniciais(this.idstatuspadraotela)
        }).catch(()=>{
          this.$alertar("warning","Não foi possível Cancelar o Pedido!","=(")
        })



      },

  },
  async mounted(){

      this.$store.dispatch("set_titulo", "Garçom")
      await this.listarPedidosIniciais(this.idstatuspadraotela)

      const self = this
      this.sockets.subscribe('novo_pedido_garcom',()=>{
          self.$alertar("warning","Novo Pedido Pronto!","=D")
          var snd = new Audio("data:audio/wav;base64,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");
          snd.volume = 1.0
          snd.play();
          // self.listarPedidosIniciais(self.idstatuspadraotela)
           setTimeout(() => {
              self.listarPedidosIniciais(self.idstatuspadraotela)
            }, 3000);
        }
      )

      // this.sockets.subscribe('notificar_troca_status_pedido',() => {
      //   setTimeout(() => {
      //     self.listarPedidosIniciais(self.idstatuspadraotela)
      //   }, 3000);
      // });

      const { numpedido } = this.$route.query
      if(numpedido){
        this.query = numpedido
        let pedido = this.ojbPedidos.listadepedidos.filter(pedido => pedido.numpedido == numpedido)[0]
        this.setarPedido(pedido)
      }

      await this.$http.post('pdv/buscarparametros',{chave:'ENTREGAR_E_FECHAR_COMANDA_WEB'})
      .then(resp =>{
          this.marcarefecharcomandaweb = resp.data[0].valor == 'true'?true:false
      }).catch(error =>{
          alert(error)
      })

  },
  beforeDestroy(){
      this.sockets.unsubscribe("novo_pedido_garcom")
  }

};
</script>


<style scoped>

</style>
